export type NavItem = {
  label: string
  href: string
}

export const siteNavigation: NavItem[] = [
  { label: 'Features', href: '/features' },
  { label: 'Solutions', href: '/solutions' },
  { label: 'For agencies', href: '/agencies' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Compare', href: '/compare' },
  { label: 'Blog', href: '/blog' },
]

// Rendered in the footer's bottom bar rather than as a fourth column — the
// conventional placement, and it keeps these reachable from every marketing
// page without competing with product navigation.
export const legalLinks: NavItem[] = [
  { label: 'Terms of Use', href: '/terms' },
  { label: 'Privacy Policy', href: '/privacy' },
]

export const footerColumns = [
  {
    title: 'Platform',
    links: [
      { label: 'Features', href: '/features' },
      { label: 'Agencies & developers', href: '/agencies' },
      { label: 'Integrations', href: '/integrations' },
      { label: 'WordPress plugin', href: '/wordpress-plugin' },
      { label: 'Live Giving', href: '/live' },
      { label: 'Pricing', href: '/pricing' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: '/about' },
      { label: 'Contact', href: '/contact-sales' },
      { label: 'Sign up', href: '/signup' },
      { label: 'Login', href: '/login' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Manage my donation', href: '/manage-donation' },
      { label: 'Blog', href: '/blog' },
      { label: 'Resources', href: '/resources' },
      { label: 'Comparisons', href: '/compare' },
      { label: 'Editorial standards', href: '/editorial-standards' },
      { label: 'Free tools', href: '/tools' },
    ],
  },
]
